export default function updateHiddenFieldsFromGroups() {

    // Alle DIV-Container, die die relevanten Inputs enthalten
    const groups = document.querySelectorAll('.input-json-group-wrapper');

    groups.forEach(group => {
        // HiddenField direkt oberhalb des Containers holen
        // (das vorherige Geschwisterelement)
        const hiddenField = group.parentElement.querySelectorAll('input.input-json')[0];

        // Alle Inputs im Container sammeln
        const inputs = group.querySelectorAll('input, select, textarea');

        const data = {};

        inputs.forEach(input => {
            // Falls ein Name existiert und ein Wert
            if (input.name) {
                data[input.name] = input.value;
            }
        });

        // In JSON konvertieren
        const jsonValue = JSON.stringify(data);
        // HiddenField befüllen
        hiddenField.value = jsonValue;
    });
};